import styled from 'styled-components';

export const NoSurveyContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  h4 {
    color: ${(props) => props.theme.colors.grey1};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    margin: 0;
  }

  p {
    color: ${(props) => props.theme.colors.grey2};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }
`;
